import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "reddog_cart_v1";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const raw = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch {}
    }, [items]);

    const addItem = (product, quantity = 1) => {
        setItems((prev) => {
            const idx = prev.findIndex((i) => i.product_id === product.id);
            if (idx >= 0) {
                const next = [...prev];
                next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
                return next;
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    price: product.price,
                    image_url: product.image_url,
                    quantity,
                },
            ];
        });
    };

    const updateQuantity = (productId, quantity) => {
        if (quantity <= 0) return removeItem(productId);
        setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, quantity } : i)));
    };

    const removeItem = (productId) => {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    };

    const clearCart = () => setItems([]);

    const itemCount = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

    return (
        <CartContext.Provider
            value={{ items, addItem, updateQuantity, removeItem, clearCart, itemCount, subtotal }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used inside CartProvider");
    return ctx;
};
